import React, { Component } from 'react'
import { PropTypes } from 'prop-types'
// import { get } from 'lodash'
import { Select } from 'components/fields'
import { apiCommon } from 'helpers/decorators/api'

@apiCommon({
  countriesWithStructure: true
})
class FilterByCountry extends Component {
  static propTypes = {
    label: PropTypes.string,
    name: PropTypes.string,
    intlKey: PropTypes.string
  }

  static defaultProps = {
    label: 'Award Unit',
    intlKey: 'label.award_unit',
    name: 'country_id'
  }

  render() {
    const { label, name, intlKey } = this.props

    return (
      <Select
        label={label}
        intlKey={intlKey}
        name={name}
        options={[]}
        searchable
      />
    )
  }
}

export default FilterByCountry
